export default __webpack_public_path__ + "static/media/P308a.d6e67242.mp3";